export { translations } from './translations';
export { getDesignSystemTranslations } from './getDesignSystemTranslations';
